import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
	'use strict';

	angular
        .module('surveyControllers')
        .factory('surveyService', service);

	service.$inject = ['$http', '$q'];

	function service($http, $q) {
		var baseUrl = environment.apiUrl + '/Pilot/api/Survey';

		var surveyUrl = function (slugObject) {
		    return baseUrl + '/' +
                   slugObject.Year + '/' + slugObject.Month + '/' + slugObject.Day + '/' +
                   slugObject.Title;
		}

		var service = {
		    getAvailableSurveys : getAvailableSurveys,
		    getSurvey           : getSurvey,
		    submitSurvey        : submitSurvey,
		    getPage             : getPage,
		    getNextPageToProcess: getNextPageToProcess,
		    getNextPage         : getNextPage,
		    getPreviousPage     : getPreviousPage,
		    addResponse         : addResponse,
		    deleteResponse      : deleteResponse
		};
		return service;

		////////////

		// Survey

		function getAvailableSurveys() {
		    var reqUrl = baseUrl + '/Available';

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

		function getSurvey(slugObject) {
		    var reqUrl = surveyUrl(slugObject);

			return $http.get(reqUrl)
                        .then(function (response) {
                        	return response.data;
                        });
		}

		function submitSurvey(slugObject) {
		    var reqUrl = surveyUrl(slugObject) + '/Submit';

		    return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

		function getPage(slugObject, pageNumber) {
		    var reqUrl = surveyUrl(slugObject) + '/Page/' + pageNumber;

		    return $http.get(reqUrl)
            .then(function (response) {
                return response.data;
            });
		}

		function getNextPageToProcess(slugObject) {
		    var reqUrl = surveyUrl(slugObject) + '/Page/NextToProcess';

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

		function getNextPage(slugObject, actualPage) {
		    var reqUrl = surveyUrl(slugObject) + '/Page/Next';

		    return $http.post(reqUrl, actualPage)
                        .then(function (response) {
                            return response.data;
                        });
		}

		function getPreviousPage(slugObject, actualPage) {
		    var reqUrl = surveyUrl(slugObject) + '/Page/Previous';

		    return $http.post(reqUrl, actualPage)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Responses

		function addResponse(slugObject, campaignPartId, questionId, response) {
		    var reqUrl = surveyUrl(slugObject) +
                         '/Part/' + campaignPartId +
                         '/Question/' + questionId +
                         '/Response';

		    return $http.post(reqUrl, {
		                    response: response
		                })
                        .then(function (response) {
                            return response.data;
                        });
		}

		function deleteResponse(slugObject, campaignPartId, questionId, response) {
		    var questionChoiceId = '';
		    if (!_.isUndefined(response.QuestionChoiceID)) {
		        questionChoiceId = '/' + response.QuestionChoiceID;
		    }

		    var reqUrl = surveyUrl(slugObject) +
                         '/Part/' + campaignPartId +
                         '/Question/' + questionId +
                         '/Response' + questionChoiceId;

		    return $http.delete(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}
	}
})();
